module.exports = __webpack_public_path__ + "static/media/currencylayer.cadd1d46.svg";